<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <CustomerGroupName :group="group"/>
      </v-flex>
      <v-flex
        xs12
      >
        <CustomerGroupCustomers :group="group"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerGroupName from './CustomerGroupName'
import CustomerGroupCustomers from './CustomerGroupCustomers'
import LoadingState from '@/components/LoadingState'

export {
  CustomerGroupName,
  CustomerGroupCustomers
}

export default {
  name: 'GroupSingle',

  components: {
    CustomerGroupName,
    CustomerGroupCustomers,
    LoadingState
  },

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  computed: {
    loading () {
      return Object.entries(this.group).length === 0
    },

    disabled () {
      return this.group.inProgress || !this.group.isDirty()
    }
  }
}
</script>
